import React from 'react'
import DisableApplications from './DisableApplications'
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const DisableRenewApplications = () => {

  const editApplicationPermission = checkPermission(
    permissionsConfig.editRenewDisabledApplications.role,
    permissionsConfig.editRenewDisabledApplications.action,
    permissionsConfig.editRenewDisabledApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteRenewDisabledApplications.role,
    permissionsConfig.deleteRenewDisabledApplications.action,
    permissionsConfig.deleteRenewDisabledApplications.type
  );

    return (
        <DisableApplications application_type="1" pageFrom="renew/disable" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></DisableApplications>
    )
}

export default DisableRenewApplications